import React  from 'react'
import styled from 'styled-components'
import ResourceList from './components/resource-list'
const Page = styled.div`
`

const Content = styled.div`
  margin: 0 auto;
  max-width: 1200px;
  padding: 32px 16px;

  @media(max-width: 900px) {
    padding: 16px 8px;
  }
`

const Resources = () => {
  return (
    <Page>
      <Content>
        <ResourceList />
      </Content>
    </Page>
  )
}

export default Resources